import { isWeb } from '@commonStyle';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f8fafc',
    paddingHorizontal: 20,
    paddingTop: 40,
  },
  
  titre: {
    fontSize: 28,
    fontWeight: '700',
    color: '#1e293b',
    textAlign: 'center',
    marginBottom: 30,
    letterSpacing: -0.5,
  },
  
  listContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
  },
  
  listContent: {
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  
  pressableItem: {
    padding: 20,
    borderRadius: 16,
    backgroundColor: '#ffffff',
    borderWidth: 1,
    borderColor: '#e2e8f0',
    gap: 18,
    marginBottom: 12,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 3,
    width: isWeb ? '65%' : '100%',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    flexWrap: 'wrap-reverse',
  },

  pressableItemResponsive: {
    flexDirection: 'column-reverse',
    justifyContent:'center',
    alignItems: 'center',
    width: '100%',
    flexWrap: 'nowrap'
  },
  
  pressableItemActive: {
    backgroundColor: '#f0f9ff',
    borderColor: '#0ea5e9',
    transform: [{ scale: 0.98 }],
  },
  
  tenantName: {
    fontSize: 18,
    fontWeight: '600',
    color: '#1e293b',
    marginBottom: 4,
  },
  
  componentName: {
    fontSize: 14,
    color: '#64748b',
    fontWeight: '500',
    fontStyle: 'italic',
  },
  
  itemText: {
    fontSize: 16,
    color: '#475569',
  },
  
  emptyContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 60,
  },
  
  emptyText: {
    fontSize: 16,
    color: '#94a3b8',
    textAlign: 'center',
    lineHeight: 24,
  },

  descriptif: {
    flex:1,
    minWidth: '50%',
    width: '100%',
  },

  logo: {
    justifyContent: 'center',
    alignItems: 'center',
  }
});

export default styles;
